export const loadStatic = async () => {
    const response = await fetch("/static.json");
    const config = await response.json();
    return config;
};